import type { ReportFilterValues } from '../types';

// The "Dữ liệu & báo cáo" page opened on one report, already filtered; for a page's "Xuất Excel" button.
export function reportLink(reportId: string, filters: ReportFilterValues = {}) {
    const params = new URLSearchParams({ report: reportId });
    for (const [key, value] of Object.entries(filters)) {
        if (value) params.set(key, String(value));
    }
    return `/reports?${params.toString()}`;
}
